import React, { useState } from 'react';
import { Typography } from 'antd';
import Modal from 'antd/lib/modal/Modal';

import { useMaintenance } from '@context/MaintenanceContext';

import style from './MaintenanceNotification.module.less';

const { Title } = Typography;

const MaintenanceNotification = () => {
  const { message, maintenance } = useMaintenance();

  if (!message) return null;

  if (message && maintenance) return null;

  const [isPopupVisible, setPopupVisible] = useState<boolean>(true);

  const modalConfig = {
    visible: isPopupVisible,
    centered: true,
    closable: true,
    closeIcon: 'X',
    mask: true,
    maskClosable: true,
    width: 700,
    title: null,
    footer: null,
    onCancel: () => {
      setPopupVisible(false);
    },
    bodyStyle: { padding: '0' },
  };

  return (
    <Modal {...modalConfig}>
      <section className={style.container}>
        <Title level={4} className={style.highlight}>
          THÔNG BÁO
        </Title>
        <p className={style.highlight}>v/v Bảo trì hệ thống</p>
        <p>{message}</p>
      </section>
    </Modal>
  );
};

export default MaintenanceNotification;
